import { OAUTH_SESSION_ID_COOKIE } from 'config/cookie';
import { cookiesInstance } from './cookiesInstance';

export const set = (value: string) => cookiesInstance.set(OAUTH_SESSION_ID_COOKIE, value);

export const get = (): string | undefined => {
  return cookiesInstance.get(OAUTH_SESSION_ID_COOKIE);
};

export const remove = () => cookiesInstance.remove(OAUTH_SESSION_ID_COOKIE);
